import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import { useEffect } from 'react';

interface OffcanvasPanelProps {
    isOpen: boolean;
    onClose: () => void;
    heading?: React.ReactNode;
    children: React.ReactNode;
    stickyHeader?: boolean;
    mobileWidth?: string;
    desktopMaxWidth?: string;
    zIndex?: number;
}

const OffcanvasPanel: React.FC<OffcanvasPanelProps> = ({
    isOpen,
    onClose,
    heading,
    children,
    stickyHeader = true,
    mobileWidth = 'w-full',
    desktopMaxWidth = 'md:max-w-xl',
    zIndex = 50
}) => {
    useEffect(() => {
        if (isOpen) {
            // Push state for back button handling
            window.history.pushState(null, '', window.location.href);
            const handlePopState = () => onClose();
            window.addEventListener('popstate', handlePopState);

            // Lock scroll
            document.body.style.overflow = 'hidden';
            document.body.style.paddingRight = 'var(--scrollbar-compensation)';

            return () => {
                window.removeEventListener('popstate', handlePopState);
            };
        } else {
            // Unlock scroll
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
        }

        return () => {
            // Cleanup
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
        };
    }, [isOpen]);

    return (
        <>
            {/* Backdrop */}
            {isOpen && (
                <div
                    className={`fixed inset-0 bg-black bg-opacity-50 z-${zIndex}`}
                    onClick={onClose}
                />
            )}
            <div
                className={`fixed inset-y-0 right-0 bg-white z-${zIndex} transform transition-all duration-500 ease-in-out ${desktopMaxWidth} ${mobileWidth} ${
                    isOpen ? 'translate-x-0' : 'translate-x-full'
                } flex flex-col`}
            >
                {/* Header */}
                <div className={`bg-white${stickyHeader ? '/90 backdrop-blur-sm' : ''} ${heading ? 'border-b border-gray-100' : ''} p-4`}>
                    <div className="relative">
                        <button 
                            onClick={onClose}
                            className="absolute right-0 top-0"
                        >
                            <FontAwesomeIcon icon={faCircleXmark} className="text-2xl text-black" aria-hidden="true" />
                            <span className="sr-only">Close panel</span>
                        </button>
                        {heading && (
                            <div>
                                {heading}
                            </div>
                        )}
                    </div>
                </div>

                {/* Content */}
                <div className="flex-1 overflow-y-auto">
                    {children}
                </div>
            </div>
        </>
    );
};

export default OffcanvasPanel; 